'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocale = setLocale;

var _apiClient = require('../utils/http/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *   This DAO is for storing a user's preferred language.
 */

function setLocale(overridenLocale) {
  var headers = {};
  if (overridenLocale) {
    headers['Accept-Language'] = overridenLocale;
  }

  return _apiClient2.default.post('hubs/v2/i18n/best-match', { headers: headers }).done();
}